<template>
  <v-container v-if="seminar != null" fluid class="seminario">
    <v-row>
      <!-- next and previous buttons -->
      <v-col cols="12" md="6" lg="6" xl="6">
        <v-btn v-if="seminar_index > 0" class="elevation-0" plain @click="goTo(seminar_index - 1)">
          <v-icon>mdi-chevron-left</v-icon>
          <div class="body-2">{{ previousSeminar }}</div>
        </v-btn>
      </v-col>
      <v-col cols="12" md="6" lg="6" xl="6" class="d-flex flex-row-reverse">
        <v-btn
          v-if="seminar_index < seminarios.length - 1"
          class="elevation-0"
          plain
          @click="goTo(seminar_index + 1)"
        >
          <div class="body-2">{{ nextSeminar }}</div>
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-breadcrumbs
            class="pt-0 pr-0 pl-4 breadcrumbs"
            :items="route"
            divider="/"
          ></v-breadcrumbs>
        </v-col>
        <v-col data-aos="fade-up" class="d-flex flex-column align-center" cols="12" md="12">
          <!-- <v-img :src="image" :alt="seminar.name" position="center bottom" height="350px" /> -->
          <v-img
            :aspect-ratio="1 / 1"
            position="left bottom"
            cover
            class="seminar-image elevation-4"
            :src="image"
          ></v-img>
          <h5 class="mt-12">{{ seminar.name }}</h5>
          <div class="body-2 mt- center-text seminar-description">{{ seminar.description }}</div>
        </v-col>
        <v-col data-aos="fade-up">
          <div class="notranslate ">
            <b>Total de videos:</b>
            <v-chip class="ml-2" color="primary" dark>
              <b>{{ videos.length }}</b>
            </v-chip>
          </div>
          <v-card class="elevation-0">
            <v-card-text>
              <v-row>
                <v-col
                  class="d-flex justify-center"
                  cols="12"
                  md="6"
                  lg="4"
                  v-for="(video, index) in videos"
                  :key="video.id"
                >
                  <video_cell :video="video" :index="index" :seminarImage="image" />
                  <!-- <VueLinkPreview :url="video.link" @click="handleClick"></VueLinkPreview> -->
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<script>
import $ from "jquery";
import VueLinkPreview from "@ashwamegh/vue-link-preview";

export default {
  name: "Seminario",
  components: {
    video_cell: () => import("@/components/Lists/SeminarVideoCell.vue"),
    VueLinkPreview
  },
  data: () => ({
    seminar: null,
    seminar_index: null,
    route: [
      {
        text: "Seminarios",
        disabled: false,
        href: "/seminarios"
      }
    ]
  }),
  methods: {
    goTo(index) {
      this.$router.push(this.seminarios[index].path);
    },
    handleClick() {
      console.log("click");
    },
    // goTo() {
    //   this.$router.push(this.path);
    // },
    getSeminar() {
      this.$info.seminarios.forEach((seminar, index) => {
        if (seminar.path == this.$route.params.seminario) {
          this.seminar = seminar;
          this.seminar_index = index;
          console.warn(seminar);
        }
      });
      // console.warn(this.$route.params.seminario);
    },
  },
  computed: {
    path() {
      return { path: `/seminarios/${this.seminar.name}` };
    },
    image() {
      return $(location).attr("origin") + "/archivos/seminarios/" + this.seminar.image;
    },
    previousSeminar() {
      return this.seminarios[this.seminar_index - 1].name;
    },
    nextSeminar() {
      return this.seminarios[this.seminar_index + 1].name;
    },
    seminarios() {
      return this.$info.seminarios;
    },
    videos() {
      // Sort the seminars based on their dates
      const videos = this.seminar.videos.sort(function(a, b) {
        var dateA = new Date(a.date);
        var dateB = new Date(b.date);
        return dateA - dateB;
      });

      // Return the sorted seminars
      return videos.reverse();
    }
  },
  created: function() {
    this.getSeminar();
    this.route.push({
      text: this.seminar.name,
      disabled: true
    });
  },
  watch: {
    "$route.params.seminario": {
      handler: function(oldValue, newValue) {
        if (oldValue != newValue && this.seminar != null) {
          this.getSeminar();
          this.route.pop();
          this.route.push({
            text: this.seminar.name,
            disabled: true
          });
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
.seminario {
  padding-top: 100px;
}
.seminar-description {
  width: 400px;
  opacity: 0.6;
  line-height: 1.5 !important;
  padding-top: 10px;
}
.seminar-image {
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  height: 325px !important;
  width: 325px !important;
  min-height: 325px !important;
  min-width: 325px !important;
  transition: all 0.3s ease-in-out;
}
@media (max-width: $screen-xl-min) {
  h5 {
    // color: red;x`
  }
}

@media only screen and (max-width: $screen-lg-min) {
  .seminario {
    padding-top: 55px;
  }
  h5 {
    // color: green;
  }
}

@media (max-width: 450px) {
  h5 {
    // color: blue;
  }
  .seminar-description {
    width: 360px;
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
